<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Uitgaven voor alimentatie aan een ex-partner en andere onderhoudsverplichtingen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Partneralimentatie is een bijdrage in de kosten van levensonderhoud van je ex-partner. Een ex-partner
                kan een ex-echtgenoot zijn of iemand met wie je hebt samengewoond, maar ook een echtgenoot van wie je
                duurzaam gescheiden leeft.
                <div class="space10"></div>

                Betaalde je in {{ this.year }} partneralimentatie? Dan mag je die aftrekken.
                <div class="space10"></div>

                Het maakt niet uit of je de partneralimentatie via de rechter of onderling met je ex-partner hebt
                geregeld. Ook andere onderhoudsverplichtingen mag je aftrekken. Het is belangrijk dat je de afspraken of
                voorlopige voorzieningen schriftelijk vastlegt en beiden ondertekent.
                <div class="space10"></div>

                <b>Je ex-partner woonde in de woning waarvan je mede-eigenaar was</b><br/>
                Ben je gescheiden of uit elkaar gegaan en bleef je (vroegere) fiscale partner in de woning wonen waarvan
                jij mede-eigenaar was? En was dit als gevolg van afspraken die je onderling hebt gemaakt over het
                voorzien
                in levensonderhoud? Dan mag je jouw deel van het eigenwoningforfait aftrekken als uitgave voor
                alimentatie.
                <div class="space10"></div>

                <b>Kinderalimentatie</b><br/>
                Alimentatie die je betaalde voor je kinderen is niet aftrekbaar.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Welke onderhoudsverplichtingen zijn aftrekbaar
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je mag de volgende onderhoudsverplichtingen aftrekken:
                <li class="list">periodieke betalingen van partneralimentatie</li>
                <li class="list">een afkoopsom van partneralimentatie aan je ex-echtgenoot of een koopsom voor een lijfrente die je
                    hiervoor hebt gestort bij een verzekeraar<br/>
                    Let op! Dit geldt niet in de volgende gevallen:<br/>
                    - je betaalt de afkoopsom in de periode voordat de rechter het huwelijk heeft ontbonden.
                    - je woont ongetrouwd samen met je ex-partner.
                </li>
                <li class="list">ouderdomspensioen dat je als partneralimentatie doorbetaalt
                <li class="list">betalingen voor de verrekening van pensioenrechten, lijfrenten en andere inkomensvoorzieningen
                    waarvan je
                    de betaalde premies eerder hebt afgetrokken
                <li class="list">bijstand die de Sociale Dienst aan je ex-partner geeft en op je verhaalt
                <li class="list">andere onderhoudsverplichtingen of periodieke betalingen voor verplichtingen tot schadevergoeding
                    <div class="space10"></div>

                    Niet aftrekbaar zijn:
                <li class="list">alimentatie die je voor je kinderen betaalt</li>
                <li class="list">advocaat- en proceskosten die je maakt om de partneralimentatie te verlagen of om van de
                    partneralimentatieverplichting af te komen
                </li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Partneralimentatie
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Partneralimentatie is een bijdrage in de kosten van levensonderhoud van je ex-partner. Een ex-partner
                kan een ex-echtgenoot zijn of iemand met wie je hebt samengewoond, maar ook een echtgenoot waarvan je
                duurzaam gescheiden leeft.
                <div class="space10"></div>

                Je leeft duurzaam gescheiden als je niet meer met je echtgenoot in gezinsverband samenwoont en die
                situatie niet als tijdelijk is bedoeld. De situatie is tijdelijk als jij en je echtgenoot op proef uit
                elkaar zijn. Als ten minste 1 van je definitief niet meer wil samenwonen, leef je duurzaam gescheiden.
                Als je duurzaam gescheiden leeft, word je voor de inkomstenbelasting toch als partners gezien omdat je
                nog
                gehuwd bent. Je kunt in deze situatie al partneralimentatie betalen. De alimentatie is bij de betalende
                partner aftrekbaar en bij de ontvangende partner belast. Duurzaam gescheiden leven eindigt nadat de
                rechter het huwelijk heeft ontbonden.
                <div class="space10"></div>

                Ook in de situatie dat je na echtscheiding, beëindiging van het geregistreerd partnerschap of
                beëindiging
                van de samenlevingsovereenkomst nog op hetzelfde adres staat ingeschreven en er sprake is van fiscaal
                partnerschap kan betaalde partneralimentatie nog in aftrek komen.<br/>
                Dit is het geval als je niet meer een gezamenlijke huishouding voert, maar bijvoorbeeld nog
                noodgedwongen
                bij elkaar woont in afwachting van een andere woonruimte. Indien de betaalde alimentatie voortkomt uit
                de behoeftigheid van je ex-partner (je ex-partner heeft geen/onvoldoende middelen om in het eigen
                levensonderhoud te voorzien of is niet in staat deze middelen te verwerven) kan deze nog in aftrek
                komen.

                <div class="space10"></div>
                Het maakt niet uit of je de alimentatie via de rechter hebt geregeld of met je ex-partner. Het is
                verstandig als je de afspraken of voorlopige voorzieningen schriftelijk vastlegt en beiden ondertekent.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Vroegere fiscale partner woont in koopwoning waarvan jij nog eigenaar bent
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Woont je ex-partner door een (voorlopige) partneralimentatieregeling in de woning waarvan je de
                (mede-)eigenaar bent? Dan valt de woning nog 2 jaar lang onder de eigenwoningregeling. Je mag (jouw deel
                van) het eigenwoningforfait aftrekken als partneralimentatie. Je berekent dit bedrag door het
                eigenwoningforfait te vermenigvuldigen met het percentage van je eigendom in de woning. <br/>
                Als je langer dan 2 jaar geleden uit elkaar bent gegaan, dan is de eigenwoningregeling niet meer van toepassing. Je geeft dan
                de waarde van (jouw deel van) deze woning aan als bezitting in box 3 (sparen en beleggen). De hoogte van
                de eventuele schuld vermeld je als schuld in box 3. Je mag je deel van het eigenwoningforfait als
                partneralimentatie aftrekken, ook al is het eigenwoningforfait niet van toepassing voor deze woning. Je
                rekent dit bedrag uit door het eigenwoningforfait te vermenigvuldigen met het percentage van je eigendom
                in de woning.
                <div class="space10"></div>

                Betaal je (een deel van) de rente voor je ex-partner? Dan mag je deze rente meestal aftrekken als
                partneralimentatie, ongeacht hoe lang geleden je uit elkaar bent gegaan. Zie de voorwaarden hieronder.
                <div class="space10"></div>

                Ex-partners met een eigen woning kunnen samen afspreken dat de ene partner (ook) het aandeel in de
                woonlasten van de ander betaalt. Deze afspraak kunnen zij zowel schriftelijk als mondeling maken. Als jij
                het aandeel van de ander betaalt en je ex-partner in de woning blijft wonen, mag je dit bedrag in de
                meeste gevallen aftrekken als partneralimentatie.
                <div class="space10"></div>

                Heb je geen (mondelinge of schriftelijke) afspraken gemaakt over de te betalen (hypotheek)rente? Dan mag
                je dit bedrag alleen aftrekken als je ex-partner onvoldoende inkomen heeft om zijn deel van de
                (hypotheek)rente te betalen.
                <div class="space10"></div>

                Meer over dit onderwerp lees je via het onderdeel 'Meer fiscale informatie' hieronder..
            </div>
        </div>
    </div>

</div>


